import React from 'react'
import { createRoot } from 'react-dom/client';
import Category from 'main/components/category.jsx'
import Main from 'main/components/main.jsx'
import Topics from 'main/components/topics.jsx'
import Login from 'login/Login.js'
import Settings from 'main/components/settings.jsx'
import {IstError404} from 'common/components/error.jsx'
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";

import './sass/signage.sass'
import App from "./main/components/app";
import Authentication from "./common/components/Authentication";
import SnsAuth from "./main/components/SnsAuth";
import "./sass/app.scss"

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Router>
        <Authentication>
            <RouteComponent />
        </Authentication>
    </Router>
);

export function RouteComponent(props) {
    console.log(props)
    return (
        <Routes>
            <Route path="/login" element={<Login {...props}/>} />
            <Route path="*" element={
            <App {...props}>
                <ProtectedPage/>
            </App>
            } />
        </Routes>
    )
}


export function ProtectedPage(props){
    return (
        <Routes>
            <Route path={"/"} element= {<Main {...props}/>}/>
            <Route path="/topics" element= {<Topics {...props}/>}/>
            <Route path="/topics/:id" element= {<Topics {...props}/>}/>
            <Route path="/category" element= {<Category {...props}/>}/>
            <Route path="/settings" element= {<Settings  {...props}/>}/>
            <Route path={"/snsauth/"} exact element= {
                <SnsAuth {...props}/>
            }/>
            <Route path={"/snsauth/:slug"} element= {
                <SnsAuth {...props}/>
            }/>
            <Route path="/*" element= {<IstError404 {...props}/>}/>
        </Routes>
    )
}